import { Link } from 'react-router-dom';

export default function ServicesSection() {
  const services = [
    {
      image: 'https://public.readdy.ai/ai/img_res/9c07b5c3820be1d144367d75969ca5be.jpg',
      title: '会社を売りたい方',
      description: '後継者不在、事業の選択と集中、経営者の引退など、様々な理由で会社売却をお考えの経営者様をサポートします。',
      link: '/sell',
      icon: 'ri-hand-coin-line',
      color: 'teal'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=modern%20abstract%20business%20growth%20and%20expansion%20concept%20with%20upward%20arrows%20and%20geometric%20patterns%2C%20professional%20corporate%20design%20with%20blue%20and%20indigo%20gradients%2C%20clean%20minimalist%20style%20with%20dynamic%20composition%2C%20premium%20business%20illustration&width=800&height=600&seq=service-buy-001&orientation=landscape',
      title: '会社を買いたい方',
      description: '事業拡大、新規事業参入、人材・技術の獲得など、M&Aによる成長戦略をお考えの企業様に最適な案件をご紹介します。',
      link: '/buy',
      icon: 'ri-building-line',
      color: 'blue'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=modern%20abstract%20business%20succession%20and%20continuity%20concept%20with%20connected%20nodes%20and%20flowing%20lines%2C%20professional%20corporate%20atmosphere%20with%20emerald%20and%20teal%20tones%2C%20sophisticated%20minimalist%20digital%20art%20with%20layered%20depth%2C%20premium%20quality%20illustration&width=800&height=600&seq=service-succession-001&orientation=landscape',
      title: '事業承継をお考えの方',
      description: '親族内承継、従業員承継、第三者承継など、様々な事業承継の形をご提案します。円滑な事業承継を実現します。',
      link: '/succession',
      icon: 'ri-exchange-line',
      color: 'emerald'
    }
  ];

  const colorClasses = {
    teal: {
      gradient: 'from-teal-500 to-cyan-500',
      text: 'text-teal-600',
      bg: 'bg-teal-500',
      hover: 'group-hover:text-teal-600'
    },
    blue: {
      gradient: 'from-blue-500 to-indigo-500',
      text: 'text-blue-600',
      bg: 'bg-blue-500',
      hover: 'group-hover:text-blue-600'
    },
    emerald: {
      gradient: 'from-emerald-500 to-teal-500',
      text: 'text-emerald-600',
      bg: 'bg-emerald-500',
      hover: 'group-hover:text-emerald-600'
    }
  };

  return (
    <section className="py-32 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="text-teal-600 font-bold text-sm tracking-widest uppercase mb-4 block">
            Our Services
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            サービス内容
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            あなたのニーズに合わせた最適なソリューションを提供します
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const colors = colorClasses[service.color as keyof typeof colorClasses];
            return (
              <div
                key={index}
                className="group relative bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-3"
              >
                {/* Image Container */}
                <div className="relative w-full h-72 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent`}></div>
                  
                  {/* Icon Badge */}
                  <div className={`absolute top-6 right-6 w-14 h-14 bg-gradient-to-br ${colors.gradient} rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:rotate-12 transition-all duration-500`}>
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                </div>

                {/* Content */}
                <div className="p-8">
                  <h3 className="text-2xl font-black text-gray-900 mb-4">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  
                  <Link
                    to={service.link}
                    className={`inline-flex items-center font-bold text-sm ${colors.text} ${colors.hover} transition-colors group/link whitespace-nowrap cursor-pointer`}
                  >
                    詳しく見る
                    <i className="ri-arrow-right-line ml-2 group-hover/link:translate-x-2 transition-transform"></i>
                  </Link>
                </div>

                {/* Decorative Gradient */}
                <div className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${colors.gradient} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`}></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
